import React from "react";
import PropTypes from "prop-types";

/**
 * Previous/Next navigation wrapper. Renders a single bordered row with
 * Previous on the left and Next on the right.
 */
export default function Pager({ label = "", children }) {
  return (
    <nav className="mt-6 border border-gray-300" aria-label={label || undefined}>
      <div className="flex justify-between items-center px-4 py-4">
        {children}
      </div>
    </nav>
  );
}

Pager.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Pager.defaultProps = {
  label: "",
};
